import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

export function passwordMatcher(c: AbstractControl) {
    if (!c.get('adminPassword') || !c.get('adminPasswordConfirmation'))
        return null;

    return c.get('adminPassword').value === c.get('adminPasswordConfirmation').value
        ? null : { 'nomatch': true };
}

@Directive({
    selector: '[password-matcher]',
    providers: [
        { provide: NG_VALIDATORS, multi: true, useValue: passwordMatcher }
    ]
})
export class PasswordMatcherDirective {


}